import { IsRedemptionOnCurrentDevice } from './types';

export const isRedemptionOnCurrentDevice = ({ isMobile }: IsRedemptionOnCurrentDevice) => isMobile;
